'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgWiFiOff32 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { fill: "none", d: "M.5 0h32v32H.5z" }), jsxRuntime.jsx("path", { d: "M17.148 19.36a1.95 1.95 0 1 1-2.488 2.488m6.896-5.704A7.125 7.125 0 0 0 16.5 14.05c-1.975 0-3.762.8-5.056 2.094m13.904-3.63A12.475 12.475 0 0 0 16.5 8.85c-3.455 0-6.583 1.4-8.848 3.665M9.35 23.15l15.6-15.6", strokeLinecap: "square", stroke: "currentColor" })] }))] })));
};

exports.default = SvgWiFiOff32;
